import React, { useState, useEffect } from 'react';

const PdfTextMultiline = ({ page, inputId, value, onChange, place_holder = "Enter text" }) => {
  const [inputValue, setInputValue] = useState('');

  // Sync internal state with parent value prop
  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    onChange(page, inputId, newValue);
  };

  return (
    <div className="pdf-text-multiline">
      <textarea
        placeholder={place_holder}
        value={inputValue}
        onChange={handleInputChange}
        className="pdf-text-multiline-input"
        rows={3}
      />
    </div>
  );
};

export default PdfTextMultiline;
